<template>
  <div class="message-gif">
    <img alt="GIF" class="message-gif__image" :src="gifUrl" />
    <span class="message-gif__tag">GIF</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      url: ''
    })
  }
})

const gifUrl = computed(() => props.message.url || '')
</script>

<style lang="scss" scoped>
.message-gif {
  position: relative;
  display: inline-block;
  width: 180px;
  height: 180px;
  overflow: hidden;
  line-height: 0;
  border-radius: 8px;

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__tag {
    position: absolute;
    top: 8px;
    left: 8px;
    box-sizing: border-box;
    height: 20px;
    padding: 0px 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    color: #323233;
    background: #f7f8fa;
    border-radius: 99px;
  }
}
</style>
